import { LogLevel } from '@azure/msal-browser';

/* Microsoft Entra ID (Azure AD) single sign-on settings, read from environment variables (see .env.example).
 * If REACT_APP_AZURE_CLIENT_ID is not set - or the app is built in forced demo mode - sign-in is switched off
 * and the app behaves exactly as before. */
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || 'common';

export const authEnabled = !!clientId && process.env.REACT_APP_DEMO !== 'true' && process.env.REACT_APP_AUTH !== 'saml';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => { if (!containsPii && level <= LogLevel.Warning) console.warn(message); },
    },
  },
};

/* Scopes asked for at sign-in. Add the backend API scope (e.g. api://<api-client-id>/access_as_user) so the
 * access token sent to /api is issued for your API; otherwise only the basic profile scopes are requested. */
const apiScope = process.env.REACT_APP_AZURE_API_SCOPE;
export const loginRequest = { scopes: ['openid', 'profile', 'User.Read'] };
export const apiRequest = { scopes: apiScope ? [apiScope] : loginRequest.scopes };

/* SAML 2.0 sign-in handled by the backend in server/ (REACT_APP_AUTH=saml). The browser only holds an HttpOnly session cookie. */
export const samlEnabled = process.env.REACT_APP_AUTH === 'saml';
